import { reactive } from "vue";

export default reactive({
  sharedFilterId: "",
  title: "",
  url: "",
  visible: false
});
